import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Typography, 
  Container, 
  IconButton, 
  Box,
  TextField,
  Button,
  Grid,
  MenuItem,
  Paper,
  Divider
} from '@mui/material';
import { Close, Email, Phone, Chat } from '@mui/icons-material';

const Support = ({ open, onClose }) => {
    return (
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="md" 
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4" color="#0d9488">
              Support
            </Typography>
            <IconButton onClick={onClose} aria-label="close">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent dividers>
          <Container>
            <Typography variant="h6" gutterBottom>
              How Can We Help You?
            </Typography>
            <Typography paragraph>
              We're here to help with any questions or issues you may have. Choose from the options below or fill out our support form.
            </Typography>
            
            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Email sx={{ color: "#0d9488", mb: 2 }} fontSize="large" />
                  <Typography variant="h6" gutterBottom>
                    Email Support
                  </Typography>
                  <Typography variant="body2" paragraph>
                    Get a response within 24 hours
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#0d9488" }}>
                    support@searcheble.com
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Chat sx={{ color: "#0d9488", mb: 2 }} fontSize="large" />
                  <Typography variant="h6" gutterBottom>
                    Live Chat
                  </Typography>
                  <Typography variant="body2" paragraph>
                    Available Monday-Friday
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#0d9488" }}>
                    9AM - 5PM EST
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Phone sx={{ color: "#0d9488", mb: 2 }} fontSize="large" />
                  <Typography variant="h6" gutterBottom>
                    Phone Support
                  </Typography>
                  <Typography variant="body2" paragraph>
                    Premium plans only
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#0d9488" }}>
                    1-800-SEARCH
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
            
            <Divider sx={{ my: 4 }} />
            
            <Typography variant="h6" gutterBottom>
              Contact Support
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Name"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  margin="normal"
                  variant="outlined"
                  type="email"
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Support Category"
                  margin="normal"
                  variant="outlined"
                  defaultValue=""
                >
                  <MenuItem value="">Select an option</MenuItem>
                  <MenuItem value="technical">Technical Issue</MenuItem>
                  <MenuItem value="billing">Billing Question</MenuItem>
                  <MenuItem value="account">Account Management</MenuItem>
                  <MenuItem value="feature">Feature Request</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </TextField>
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Describe your issue"
                  margin="normal"
                  variant="outlined"
                  multiline
                  rows={4}
                />
              </Grid>
              
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  sx={{ 
                    mt: 2, 
                    bgcolor: "#0d9488",
                    '&:hover': {
                      bgcolor: "#0b877b"
                    }
                  }}
                  size="large"
                >
                  Submit Ticket
                </Button>
              </Grid>
            </Grid>
            
            <Typography paragraph sx={{ mt: 4, fontStyle: 'italic' }}>
              For urgent matters, please contact us directly at <span style={{ color: "#0d9488" }}>support@searcheble.com</span>
            </Typography>
          </Container>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default Support;